export type AuthProvider = "entra";

function parseProvider(raw: string | undefined): AuthProvider {
    const v = (raw || "entra").trim().toLowerCase();
    if (v === "entra" || v === "msal" || v === "azure") return "entra";
    return "entra";
}

/** Server-side provider (API routes, middleware). */
export function getAuthProvider(): AuthProvider {
    return parseProvider(process.env.AUTH_PROVIDER);
}

/** Client-side provider (AuthContext, sign-in UI). */
export function getClientAuthProvider(): AuthProvider {
    return parseProvider(process.env.NEXT_PUBLIC_AUTH_PROVIDER || process.env.AUTH_PROVIDER);
}

export function isEntraConfigured(): boolean {
    return Boolean(getEntraClientId() && getEntraAuthority());
}

export function getEntraAuthority(): string | undefined {
    return (
        process.env.NEXT_PUBLIC_ENTRA_AUTHORITY ||
        process.env.ENTRA_AUTHORITY ||
        process.env.NEXT_PUBLIC_AZURE_AD_B2C_AUTHORITY
    );
}

export function getEntraClientId(): string | undefined {
    return process.env.NEXT_PUBLIC_ENTRA_CLIENT_ID || process.env.ENTRA_CLIENT_ID;
}

/** Savira MCP API resource app (token audience for M2M access tokens). */
export function getMcpApiAppId(): string | undefined {
    return process.env.MCP_API_APP_ID?.trim() || undefined;
}

export function getMcpApiIdentifierUri(): string | undefined {
    return process.env.MCP_API_IDENTIFIER_URI?.trim() || undefined;
}

/** MCP client app used for client-credentials token acquisition (server-side only). */
export function getMcpClientId(): string | undefined {
    return process.env.MCP_CLIENT_ID?.trim() || undefined;
}

export function getMcpClientSecret(): string | undefined {
    return process.env.MCP_CLIENT_SECRET?.trim() || undefined;
}

export function getMcpApiAudiences(): string[] {
    const audiences = [getMcpApiAppId(), getMcpApiIdentifierUri()].filter(
        (v): v is string => Boolean(v),
    );
    return [...new Set(audiences)];
}

export function isMcpApiConfigured(): boolean {
    return getMcpApiAudiences().length > 0;
}
